import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { GetTagsForQuizzesOptions, getTagsForQuizzes } from '~/monolith-api';

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getTagsForQuizzes({ apiClient: monolithClient, ...req.body });
      res.status(200).json(result);
   },
});

export const getLearnosityTagsForQuizzes = (
   options: GetTagsForQuizzesOptions
): ReturnType<typeof getTagsForQuizzes> => {
   return bff()
      .post('/quizzes/getTagsForQuizzes', {
         learnosityReferences: options.learnosityReferences,
      })
      .then(tagResponse => {
         return tagResponse.data;
      });
};
